var map = {
	"./de/mecha-active-btn.png": "7DPn",
	"./en/mecha-active-btn.png": "JjpH",
	"./es/mecha-active-btn.png": "UL0W",
	"./fr/mecha-active-btn.png": "UUKv",
	"./ja/mecha-active-btn.png": "ZmLv",
	"./ko/mecha-active-btn.png": "MvfJ",
	"./pt/mecha-active-btn.png": "AsMc",
	"./ru/mecha-active-btn.png": "hlJb",
	"./tc/mecha-active-btn.png": "zIXg",
	"./th/mecha-active-btn.png": "/+1r"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "JL6e";